import { cn } from "@/utils/cn";
import type { Owner } from "@/utils/types/flavor";

type OwnerPillProps = {
  owner: Owner;
  className?: string;
};

export function OwnerPill({ owner, className }: OwnerPillProps) {
  if (owner.kind === "me") {
    return (
      <span className={cn("owner-pill owner-pill--me", className)} title="Owned by me">
        Me
      </span>
    );
  }
  return (
    <span
      className={cn("owner-pill owner-pill--org", className)}
      title={owner.label}
    >
      {owner.label}
    </span>
  );
}
